import { FormControl, LinearProgress, MenuItem, Select, SelectProps, Stack, Typography } from "@mui/material"
import { Mdc } from "features/dpcResult/types"

type MdcSelectProps = {
	list: Mdc[]
	maxCases: number
} & SelectProps<string>
export const MdcSelect = ({
	list,
	maxCases,
	...others
}: MdcSelectProps) => {
	return (
		<FormControl fullWidth>
			<Select {...others}>
				{list.map(mdc => (
					<MenuItem key={`mdc_${mdc.code}`} value={mdc.code}>
						<Stack
							direction="row"
							width="100%"
							boxSizing="border-box"
							alignItems="center"
							spacing={1}
						>
							<Typography flexGrow={1} variant="body1" component="div" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">{mdc.name}</Typography>
							<LinearProgress
								variant="determinate"
								sx={{ flexShrink: 0, height: "1rem", width: "3rem", borderRadius: 1 }}
								value={maxCases > 0 ? ((mdc.totalCases * 100) / maxCases) : 0}
							/>
						</Stack>
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
